import { AfterViewInit, Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { DashboardControl, ResourceManager, WorkingMode } from 'devexpress-dashboard';

@Component({
  selector: 'abc-dashboard',
  template: `<div [class]="'dashboard-container'"></div>`,
  standalone: true,
})
export class _AbcDashboardComponent implements AfterViewInit, OnDestroy {
  @Input() endPoint: string;
  @Input() workingMode: WorkingMode;
  @Input() ajaxHeaders: { [key: string]: any };
  @Input() autoInitialize: boolean = true;
  @Input() set initialDashboardId(value: string) {
    this._initialDashboardId = value;
    if (this.dashboardControl) {
      this.refreshControl();
    }
  }
  get initialDashboardId(): string {
    return this._initialDashboardId;
  }

  private _initialDashboardId: string;
  private dashboardControl!: DashboardControl;

  constructor(private element: ElementRef) {
    ResourceManager.embedBundledResources();
  }

  ngAfterViewInit(): void {
    if (this.autoInitialize) {
      this.refreshControl();
    }
  }

  private refreshControl(): void {
    this.dashboardControl?.dispose();
    const dashboardContainer: HTMLElement = this.element.nativeElement.querySelector('.dashboard-container');

    dashboardContainer.innerHTML = '';
    this.dashboardControl = new DashboardControl(dashboardContainer, {
      endpoint: this.endPoint ?? 'https://demos.devexpress.com/services/dashboard/api',
      workingMode: this.workingMode ?? 'ViewerOnly',
      initialDashboardId: this.initialDashboardId,
      ajaxRemoteService: {
        headers: this.ajaxHeaders,
      },
      extensions: {
        'mobile-layout': {
          mobileLayoutEnabled: 'Auto',
        },
        'dashboard-export': {
          allowExportDashboard: true,
          allowExportDashboardItems: true,
        },
      },
    });
    this.dashboardControl.render();
  }

  ngOnDestroy(): void {
    this.dashboardControl?.dispose();
  }

  public setEndPoint(endPoint: string, ajaxHeaders: { [key: string]: any }): void {
    this.endPoint = endPoint;
    this.ajaxHeaders = ajaxHeaders;

    this.refreshControl();
  }
}
